import { render, staticRenderFns } from "./BrandLogoTextboxLycee.vue?vue&type=template&id=4da8f948&"
import script from "./BrandLogoTextboxLycee.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxLycee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports